export default "__VITE_ASSET__7WebwTR___"